import { ActionTypes } from "../actions/types";
import {
    DEBUG_ENABLED,
    DEBUG_DISABLED,
    MOBILE_PREVIEW_TOGGLE,
    MOBILE_PREVIEW_ENABLED,
    MOBILE_PREVIEW_DISABLED,
} from "../actions";

const INITIAL_STATE = false;

export const mobilePreviewReducer = (state = INITIAL_STATE, action: ActionTypes) => {
    switch (action.type) {
        case DEBUG_ENABLED:
        case DEBUG_DISABLED:
            return INITIAL_STATE;
        case MOBILE_PREVIEW_TOGGLE:
            return !state;
        case MOBILE_PREVIEW_ENABLED:
            return true;
        case MOBILE_PREVIEW_DISABLED:
            return false;
        default:
            return state;
    }
};
